import { Center } from '@chakra-ui/react';
import { Divider, Text } from '@diamond/shared/ui';
import { memo } from 'react';

import { ProductCounterProps } from './types';

const ProductCounter = memo(({ itemsLength }: ProductCounterProps) => {
  if (itemsLength <= 1) {
    return null;
  }

  return (
    <>
      <Divider borderWidth="1px" borderColor="gray.33" />
      <Center>
        <Text> +{itemsLength - 1} Produk Lainnya</Text>
      </Center>
    </>
  );
});

ProductCounter.displayName = 'ProductCounter';

export { ProductCounter };
